import { theme } from 'styled-tools';
import styled from './styled.js';
import { c as _objectWithoutPropertiesLoose, a as _extends } from './chunk-79dadc73.js';
import { createElement } from 'react';
import { a as as } from './as-39ca1b5e.js';
import { func } from 'prop-types';
import Box from './Box.js';
import { a as callAll } from './chunk-11bd1c20.js';

var HiddenHideComponent = function HiddenHideComponent(_ref) {
  var onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

  return createElement(Box, _extends({
    onClick: callAll(props.hide, onClick)
  }, props));
};

var HiddenHide = styled(HiddenHideComponent).withConfig({
  displayName: "HiddenHide",
  componentId: "nbepnv-0"
})(["", ";"], theme("HiddenHide")); // @ts-ignore

HiddenHide.propTypes = {
  hide: func.isRequired,
  onClick: func
};
var HiddenHide$1 = as("button")(HiddenHide);

var HiddenShowComponent = function HiddenShowComponent(_ref) {
  var onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

  return createElement(Box, _extends({
    onClick: callAll(props.show, onClick)
  }, props));
};

var HiddenShow = styled(HiddenShowComponent).withConfig({
  displayName: "HiddenShow",
  componentId: "w6ef6h-0"
})(["", ";"], theme("HiddenShow")); // @ts-ignore

HiddenShow.propTypes = {
  show: func.isRequired,
  onClick: func
};
var HiddenShow$1 = as("button")(HiddenShow);

var HiddenToggleComponent = function HiddenToggleComponent(_ref) {
  var onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["onClick"]);

  return createElement(Box, _extends({
    onClick: callAll(props.toggle, onClick)
  }, props));
};

var HiddenToggle = styled(HiddenToggleComponent).withConfig({
  displayName: "HiddenToggle",
  componentId: "kd7ngs-0"
})(["", ";"], theme("HiddenToggle")); // @ts-ignore

HiddenToggle.propTypes = {
  toggle: func.isRequired,
  onClick: func
};
var HiddenToggle$1 = as("button")(HiddenToggle);
export { HiddenHide$1 as a, HiddenShow$1 as b, HiddenToggle$1 as c };